import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useAuth } from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginForgotPasswordModal } from "../modals/LoginForgotPasswordModal";

export const LoginForm = () => {
  const { publicAxios, setToken } = useAuth();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotPasswordModalVisible, setForgotPasswordModalVisible] =
    useState(false);
  const [pageHeaderMsg, setPageHeaderMsg] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleEmail = (e) => {
    e.preventDefault();
    setEmail(e.currentTarget.value);
  };

  const handlePassword = (e) => {
    e.preventDefault();
    setPassword(e.currentTarget.value);
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setEmailInvalid(false);
    setPasswordInvalid(false);
    if (!email) {
      setEmailInvalid(true);
      setErrMsg("Please enter a valid email");
      return;
    }
    if (!password) {
      setPasswordInvalid(true);
      setErrMsg("Please enter a password");
      return;
    }

    try {
      setLoading(true);
      const response = await publicAxios().post(
        "/auth/login",
        {},
        {
          auth: {
            username: email,
            password: password,
          },
          params: {
              need_refresh: "false",
              request_role: "STAFF"
          },
        },
      );

      const accessToken = response.data.token;
      setToken(accessToken);
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setEmailInvalid(true);
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setEmailInvalid(true);
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setEmailInvalid(true);
        setErrMsg("Unauthorized");
      } else if (err.response?.status === 403) {
        setEmailInvalid(true);
        setErrMsg("Forbidden");
      } else {
        setEmailInvalid(true);
        setErrMsg("Login Failed");
      }
      setLoading(false);
    }
  };

  const displayMessageHeader = () => {
    if (pageHeaderMsg === null) return null;
    return (
      <Container fluid>
        <p className={pageHeaderMsg.className}> {pageHeaderMsg.msg} </p>
      </Container>
    );
  };

  return (
    <div className={"w-50 mx-auto"}>
      {displayMessageHeader()}
      <h2 className={"text-axis-offblack fw-bold h1 m-0 p-0"}>Welcome back.</h2>
      <p className={" m-0 p-0 mb-5 text-axis-offblack"}>
        Sign into your account below.
      </p>

      <Form noValidate onSubmit={onLogin}>
        <Form.Group as={Row} controlId="formBasicEmail" className={"mb-3"}>
          <Form.Label className={"m-0 p-0 mb-1 text-axis-offblack"}>
            Email Address
          </Form.Label>
          <Form.Control
            type={"email"}
            tabIndex={1}
            placeholder={"name@email.co.uk"}
            required
            onChange={handleEmail}
            isInvalid={emailInvalid}
          />
          <Form.Control.Feedback className={"p-0 m-0 mb-2"} type={"invalid"}>
            {errMsg}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Row} controlId={"formBasicPassword"}>
          <Container fluid className={"p-0 m-0 mb-2"}>
            <Row className={"p-0 m-0"}>
              <Col className={"m-0 p-0"}>
                <Form.Label className={"m-0 p-0 text-axis-offblack"}>
                  Password
                </Form.Label>
              </Col>
              <Col
                className={
                  "text-axis-link m-0 p-0 text-decoration-none pointer"
                }
                as={"a"}
                onClick={() => setForgotPasswordModalVisible(true)}
              >
                <p className={"m-0 p-0 text-end"}>Forgot password?</p>
              </Col>
            </Row>
          </Container>
          <Form.Control
            tabIndex={2}
            type={"password"}
            placeholder={"Password"}
            required
            isInvalid={passwordInvalid}
            onChange={handlePassword}
          />
          <Form.Control.Feedback className={"p-0 m-0"} type={"invalid"}>
            {errMsg}
          </Form.Control.Feedback>
          <Button
            className={"mt-5"}
            variant="offblack"
            type="submit"
            onClick={onLogin}
            disabled={loading}
          >
            Sign In
          </Button>
        </Form.Group>
      </Form>

      <LoginForgotPasswordModal
        visible={forgotPasswordModalVisible}
        close={() => setForgotPasswordModalVisible(false)}
        pageHeaderMsg={setPageHeaderMsg}
      />
    </div>
  );
};
